import { Component } from '@angular/core';

interface Benefit {
  icon: string;
  title: string;
  description: string;
}

@Component({
    selector: 'app-why-dental-tour',
    templateUrl: './why-dental-tour.component.html',
    styleUrls: ['./why-dental-tour.component.css'],
    standalone: false
})
export class WhyDentalTourComponent {
  benefits: Benefit[] = [
    {
      icon: 'ti ti-shield',
      title: 'Neutrality',
      description: 'The platform does not influence healthcare decisions, clinical choices, or proposed financial terms.'
    },
    {
      icon: 'ti ti-lock',
      title: 'Controlled Privacy',
      description: 'Your phone number is shared only if you choose to get in touch.'
    },
    {
      icon: 'ti ti-stack-2',
      title: 'More Options',
      description: 'Compare multiple indicative proposals or request direct contact.'
    },
    {
      icon: 'ti ti-stethoscope',
      title: 'Informed Choice',
      description: 'Diagnoses, treatments, and final quotations always require a clinical examination.'
    }
  ];
}
